// Charger Types translations for React Admin resource
export const chargerTypesResource = {
  name: '充電器類型',
  fields: {
    id: 'ID',
    name: '名稱',
    displayName: '顯示名稱',
    minPowerKw: '最小功率 (kW)',
    maxPowerKw: '最大功率 (kW)',
    powerRange: '功率範圍',
    colorCode: '顏色代碼',
    icon: '圖標',
    displayOrder: '顯示順序',
    createdAt: '創建時間',
    updatedAt: '更新時間',
  },
};

// Custom charger types translations for components
export const chargerTypes = {
  sections: {
    basic: '基本資訊',
    power: '功率配置',
    display: '顯示設置',
    metadata: '其他資料',
  },
  list: {
    title: '充電器類型',
    filters: {
      search: '按名稱搜尋',
    },
    empty: {
      title: '找不到充電器類型',
      subtitle: '創建您的第一個充電器類型以分類充電站。',
    },
  },
  create: {
    title: '創建充電器類型',
    subtitle: '定義新的充電器類型配置',
    backToList: '返回列表',
  },
  edit: {
    title: '編輯充電器類型',
    subtitle: '修改充電器類型配置',
    backToList: '返回列表',
  },
  delete: {
    confirmTitle: '刪除充電器類型',
    confirmContent: '您確定要刪除此充電器類型嗎？此操作無法撤銷。',
  },
  validation: {
    idTooLong: 'ID必須少於50個字符',
    idFormat: 'ID必須是小寫字母數字和連字符',
    nameTooLong: '名稱必須少於100個字符',
    displayNameTooLong: '顯示名稱必須少於100個字符',
    powerNegative: '功率不能為負數',
    powerTooHigh: '功率值太高',
    colorFormat: '顏色必須是十六進制格式（例如：#FF0000）',
    iconTooLong: '圖標名稱必須少於100個字符',
    orderNegative: '顯示順序不能為負數',
    orderTooHigh: '顯示順序太高',
  },
  helpers: {
    id: '唯一標識符（小寫，允許連字符）',
    idFixed: '創建後無法更改ID',
    name: '此充電器類型的內部名稱',
    displayName: '在應用中顯示的用戶友好名稱',
    minPower: '最小功率（千瓦）',
    maxPower: '最大功率（千瓦，留空表示無限制）',
    colorCode: '用於視覺表示的十六進制顏色代碼',
    icon: '移動應用的圖標標識符',
    displayOrder: '顯示排序順序（數字越小越靠前）',
  },
  info: {
    idNote: 'ID將用作唯一標識符，創建後無法更改',
    idCannotChange: '為保持數據完整性，創建後無法更改ID',
    powerNote: '功率範圍有助於自動分類連接器',
    displayNote: '顯示設置控制此類型在移動應用中的顯示方式',
  },
  notifications: {
    created: '充電器類型創建成功',
    updated: '充電器類型更新成功',
    deleted: '充電器類型刪除成功',
    error: {
      create: '創建充電器類型失敗',
      update: '更新充電器類型失敗',
      delete: '刪除充電器類型失敗',
    },
  },
  actions: {
    create: '創建充電器類型',
    save: '保存充電器類型',
    delete: '刪除充電器類型',
    cancel: '取消',
  },
};